import { memo } from 'react';

import { COPY } from '@/shared/constants/copies';

export const PricingPageHeading = memo(function PricingPageHeading() {
	return (
		<div className="mb-12 flex flex-col items-start gap-4 text-left">
			<h1 className="text-3xl font-semibold tracking-tight text-primary md:text-[44px]">
				{COPY.pricing.pageHeading}
			</h1>
			<p className="max-w-xl text-base font-medium leading-6 text-secondary md:text-lg">
				{COPY.pricing.pageDescription}
			</p>
		</div>
	);
});
